import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// src/fetcher/httpClient.ts
import axios from "axios";

var httpClient = function httpClient(method, url) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var otherConfigs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return axios(_objectSpread({
    url: url,
    method: method,
    headers: headers,
    data: method !== "GET" ? data : null,
    params: method === "GET" ? data : null
  }, otherConfigs)).then(function (res) {
    return Promise.resolve(res.data);
  })["catch"](function (err) {
    return (
      /* const rejection = err.response ?
        new Error(`${err.response.status}: ${err.response.data.message || url}`) :
        err */
      Promise.reject(err)
    );
  });
};

var httpClient_default = httpClient;
export { httpClient_default };